// extracted by mini-css-extract-plugin
module.exports =  {"logo":"SJU7KLao0nY0hX0tWRSW","root":"U9L_lEW05K4ltYi7p1_x"};